<template>
  <div class="content_all2" id="site_res">
    <div class="content_box">
      <div class="list_box3">
        <div class="y_ititle2">預約結果查詢</div>
        <table>
          <tr>
            <th>預約編號</th>
            <th>場地</th>
            <th>預約日期</th>
            <th>預約時段</th>
            <th>申請日期</th>
            <th>辦理期限</th>
            <!--<th>取消期限</th>-->
            <th>預約狀態</th>
            <th>操作</th>
          </tr>
          <tr v-for="(rent,index) in recordToEdit" :key="index" v-if="inCurrentPage(index)">
            <td bgcolor="#F9FAFA">{{rent.id}}</td>
            <td>{{rent.buildingName}}-{{rent.venueName}}</td>
            <td>{{rent.rentDate && rent.rentDate.split(' ')[0]}}</td>
            <td>{{rent.rentTimePeriod}}</td>
            <td>{{rent.createdAt && rent.createdAt.split(' ')[0]}}</td>
            <td>{{rent.confirmDeadLine  && rent.confirmDeadLine.split(' ')[0]}}</td>
            <!--<td></td>-->
            <td>{{showStatusRent(rent)}}</td>
            <td width="80">
              <button type="submit" class="srbtn" v-if="rent.statusRent === 1" @click="cancel(rent)"><i class="fa fa-times" aria-hidden="true"></i></button>
              <button @click="printScreen(index)" class="srbtn" v-if="printStatus(rent)"><i class="fa fa-file-text-o" aria-hidden="true"></i></button>
            </td>
          </tr>
        </table>
      </div>
      <div class="pagination-row text-center">
        <Page :total="recordToEdit.length" style="margin-top:20px" :page-size="pagesize" @on-change="changePage"></Page>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, PostErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'site_res',
  data() {
    return {
      yearUserId: sessionStorage.YearUserId,
      recordToEdit: [],
      currentPage: 1,
      pagesize: 10,
      unit: this.handleUnit()
    };
  },
  created() {
    axios.defaults.headers.common['X-Jesda-Api-Key'] = sessionStorage.getItem("TokenID");
    this.init();
  },
  methods: {
    init() {
      this.getData();
    },
    getData() {
      axios.get(API.rent_yearuserrent + `?yearUserId=${this.yearUserId}`)
        .then(response => {
          this.recordToEdit = response.data.filter(data => {
            return data.trash !== 1;
          });
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    cancel(rent) {
      let form = new FormData();

      form.append('Id', rent.id);
      form.append('yearUserId', rent.yearUserId);

      form.append('isYearUser', rent.isYearUser.toString());
      form.append('unitName', rent.unitName);
      form.append('rentDate', rent.rentDate.split(' ')[0]);
      form.append('rentTimePeriod', rent.rentTimePeriod);
      form.append('statusConfirm', rent.statusConfirm.toString());
      form.append('venueId', rent.venueId.toString());

      form.append('statusRent', 3);

      this.$Message.loading({ content: '儲存中...', duration: 0 });

      axios.post(API.rent_yearuserrent, form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          this.$Message.destroy();
          ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
          this.getData();
        })
        .catch(error => {
          this.$Message.destroy();
          PostErrorHandler.bind(this)(error, 'rent_yearuserrent');
        });
    },
    changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage(index) {
      let currentPage = this.currentPage,
        pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize
    },

    showStatusRent(rent) {
      if(rent.statusRent === 3)
        return '已取消';
      else if(rent.statusConfirm === 1)
        return '已確認';
      else if(rent.statusRent === 2) {
        if(rent.statusDraw === 1)
          return '已中籤'
        else if(rent.statusDraw === 2)
          return　'未中籤'
      }
      else if(rent.statusRent === 1)
        return '已預約';
      let show = ['', {0: '已預約',1: '已確認'}, {0:'已登記抽籤',1: '已確認'}, {0:'已取消',1: '已取消'}];
      return show[rent.statusRent][rent.statusConfirm];
    },
    handleUnit() {
      let type = ['', '男子籃球隊', '男子排球隊', '男子足球隊', '棒球隊', '女子籃球隊', '女子排球隊', '女子足球隊', '壘球隊', sessionStorage.teamTypeOther];
      let unittype = ['', '大學部', '研究所', '社團']
      return sessionStorage.UnitName + " " + unittype[sessionStorage.UnitType] + " " + type[sessionStorage.TeamType]
    },
    printScreen(index) {
      var printPage = window.open("", "Printing...", "");
      printPage.document.open();
      printPage.document.write("<HTML><head></head><BODY onload='window.print();window.close()'>");
      printPage.document.write("<div>");
      printPage.document.write(`<div id="print_parts">
      <p style="font-size: 20px; text-align: center;border-bottom: 1px solid #aaa; line-height: 40px;">臺灣大學校總區體育館及戶外運動場地
        <br>租借確認單</p>
      <table style="border-collapse: collapse;width: 100%;">
        <tr style="border: 1px solid #aaa;">
          <td style="text-align: right;border: 1px solid #aaa;padding: 10px;">預約單位</td>
          <td style="border: 1px solid #aaa;padding: 10px;">${this.unit}
          </td>
        </tr>
        <tr style="border: 1px solid #aaa;">
          <td style="text-align: right;border: 1px solid #aaa;padding: 10px;">預約日期</td>
          <td style="border: 1px solid #aaa;padding: 10px;">${this.recordToEdit[index].rentDate.split(' ')[0]}
          </td>
        </tr>
        <tr style="border: 1px solid #aaa;">
          <td style="text-align: right;border: 1px solid #aaa;padding: 10px;">預約時段</td>
          <td style="border: 1px solid #aaa;padding: 10px;">${this.recordToEdit[index].rentTimePeriod}
          </td>
        </tr>
        <tr style="border: 1px solid #aaa;">
          <td style="text-align: right;border: 1px solid #aaa;padding: 10px;">預約地點</td>
          <td style="border: 1px solid #aaa;padding: 10px;">體育館及戶外運動場區 ${this.recordToEdit[index].buildingName} - ${this.recordToEdit[index].venueName}
          </td>
        </tr>
        <tr style="border: 1px solid #aaa;">
          <td style="text-align: right;border: 1px solid #aaa;padding: 10px;">申請日期</td>
          <td style="border: 1px solid #aaa;padding: 10px;">${this.recordToEdit[index].createdAt.split(' ')[0]}
          </td>
        </tr>
      </table>
      <table style="border-collapse: collapse;width: 100%;margin-top: 80px;">
        <tr style="border: 1px solid #aaa;">
          <td style="border: 1px solid #aaa; text-align: center; height: 100px;">承租人員簽名</td>
          <td style="border: 1px solid #aaa; text-align: center; height: 100px;">承辦人員簽名</td>
        </tr>
        <tr style="border: 1px solid #aaa;">
          <td style="border: 1px solid #aaa; height: 240px;"></td>
          <td style="border: 1px solid #aaa; height: 240px;"></td>
        </tr>
      </table>
    </div>`);
      printPage.document.write("</div>");
      printPage.document.close("</BODY></HTML>");
    },
    printStatus(rent) {
      return rent.statusConfirm !== 1 &&　( rent.statusRent === 1 || (rent.statusRent === 2 && rent.statusDraw === 1) );
    },
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// SiteRes.vue?6d44d5ea